import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import NameRow from './nameRow/NameRow';
import Nav from '../shared/nav/Nav';
import DeclaredBox from './declaredBox/DeclaredBox';
import Details from './details/Details';
import { getHorseType, hasProgeny } from '../utils/horse';
import MetaData from '../shared/metaData/MetaData';
import BestOdds from '../shared/price/BestOdds';


export const getTabName = ({ tab, subTab }, { sireStatus, damStatus, weatherbysUid }) => {
    if (subTab) { return subTab; }
    if (tab) { return tab; }
    if (!sireStatus && !damStatus) { return 'form'; }
    if (sireStatus && weatherbysUid) { return 'weatherbys-overview'; }
    return 'progeny';
};

class HorsePage extends React.Component {
    constructor(props) {
        super(props);
        this.showMyRatings = this.showMyRatings.bind(this);
        this.hideMyRatings = this.hideMyRatings.bind(this);

        this.state = {
            isMyRatingShown: (props.params.subTab === 'my-ratings'),
        };
    }

    showMyRatings() {
        this.setState({ isMyRatingShown: true });
    }

    hideMyRatings() {
        this.setState({ isMyRatingShown: false });
    }

    render() {
        const { data, children, params } = this.props;
        const {
            externalLinks: { helpCenterUrl, imagesUrl },
            profile, entries, quotes,
        } = data;
        const { weatherbysUid, sireStatus, comments, horseName } = profile;

        const tabsToExclude = [
            (!weatherbysUid || !sireStatus) && 'stallionDetails',
            hasProgeny(profile) && isEmpty(entries) && 'entries',
            isEmpty(quotes) && 'quotes',
        ];

        params.mr = {
            show: this.showMyRatings,
            hide: this.hideMyRatings,
            isShown: this.state.isMyRatingShown,
        };

        return (
            <div>
                <MetaData
                    type={params.type}
                    page={getTabName(params, profile)}
                    profile={profile}
                />
                <section>
                    <NameRow
                        profile={profile}
                        params={params}
                        imagesHost={imagesUrl}
                    />
                    <Details {...profile} />
                    <DeclaredBox
                        horseName={horseName}
                        entries={entries || []}
                        comments={comments || []}
                    />
                    <BestOdds />
                </section>
                <Nav
                    params={params}
                    horseType={getHorseType(profile)}
                    helpUrl={helpCenterUrl}
                    tabsToExclude={tabsToExclude}
                />
                {cloneElement(children, { data, params })}
            </div>
        );
    }
}

HorsePage.propTypes = {
    data: PropTypes.shape({
        externalLinks: PropTypes.shape({
            imagesUrl: PropTypes.string.isRequired,
            helpCenterUrl: PropTypes.string.isRequired,
            weatherbysDomain: PropTypes.string.isRequired,
        }).isRequired,
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string,
        }).isRequired,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
        hash: PropTypes.string,
        subTab: PropTypes.string,
    }).isRequired,
    children: PropTypes.node.isRequired,
};


export default HorsePage;



// WEBPACK FOOTER //
// ./src/js/horse/HorsePage.jsx